<template>
	<div class="main-container">
        <Navbar v-bind:isTarget="false"/>
        <!-- offcanvas search component -->
        <OffcanvasSearchBox />
        <div class="software-accordion-wrapper section-space--pt_120 section-space--pb_60 gray-gradient" id="faq">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="section-title-wrapper text-center section-space--mb_60">
                            <h2 class="section-title font-weight--light mb-10 wow move-up">{{lan.key48[cur_lan]}}</h2>
                            <span class="section-text wow move-up">{{lan.key49[cur_lan]}}</span>
                        </div>
                        <!-- <b-navbar toggleable="sm" type="light" variant="light">
                            <b-collapse id="nav-text-collapse" is-nav>
                                <b-navbar-nav>
                                    <b-nav-text v-for="(faq, index) in Faqs" v-bind:key="index">{{faq.category}}</b-nav-text>
                                </b-navbar-nav>
                            </b-collapse>
                        </b-navbar> -->
                        <div>
                            <b-link v-bind:href="'#faqCategory'+index" v-for="(faq, index) in Faqs2" v-bind:key="index" class="margin-right-50">•&nbsp;&nbsp;{{faq.category}}</b-link>
                        </div>
                        <b-input-group class="mt-3 margin-bottom-20">
                            <b-form-input v-model="searchText" class="height-54"  v-on:keyup.13="searchFaq()"></b-form-input>
                            <button variant="info" class="search-faq height-54" @click="searchFaq()"><i class="far fa-search font-size-20 vertical-align-middle"></i></button>
                        </b-input-group>
                        <hr class="margin-top-60 margin-bottom-0" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="faq-wrapper">
                            <AccordionJan :toggleText="toggleText" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
        <FooterMain />
    </div>
</template>

<script>
import FooterMain from '../components/FooterMain'
	
    import AccordionJan from "../components/AccordionJan";
    import Navbar from "../components/Navbar";
    import OffcanvasSearchBox from "@/components/OffcanvasSearchBox";
    import Faqs2 from '../assets/consts/Faqs';

	export default {
		name: "app",
		components: {
			FooterMain,
            AccordionJan,
            Navbar,
            OffcanvasSearchBox
		},
        data (){
            return {
                Faqs2: Faqs2[localStorage.getItem('cur_lan') || 'jp'],
                cur_lan:localStorage.getItem('cur_lan') || 'jp',
                lan:JSON.parse(localStorage.getItem('creis_web_language_data')).data,
                searchText: '',
                toggleText: '',
                form: {
                    nickname: '',
                    email: '',
                    content: '',
                    file: null,
                },
                show: true
            }
        },
        metaInfo: {
            title: 'CREIS Japan - FAQ',
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        },
        methods: {
            searchFaq() {
                this.toggleText = this.searchText;
            },
            onSubmit(event) {
                event.preventDefault()
                // alert(JSON.stringify(this.form))
            },
            onReset(event) {
                event.preventDefault()
                // Reset our form values
                this.form.nickname = ''
                this.form.email = ''
                this.form.content = ''
                this.form.file = null
                // Trick to reset/clear native browser form validation state
                this.show = false
                this.$nextTick(() => {
                    this.show = true
                })
            }
        }
	};
</script>